import React from 'react';
import { RadioButtonWrapper } from './RadioButton.styled';

export const CHECKED = 1;
export const UNCHECKED = 2;

export interface IRadioButton {
   value: number;
   groupName: string;
   readOnly?: boolean;
   disabled?: boolean;
   callback?: any;
   className?: string;
}

// This component is completely controlled.
// TODO: Create a radio button or update this component to be used as a form input.
const RadioButton = props => {
   const { value = 2, groupName, readOnly = true, disabled = false, callback, className } = props;

   const handleChange = () => {
      if (callback && value === UNCHECKED) {
         callback();
      }
   };

   return (
      <RadioButtonWrapper
         type='radio'
         disabled={disabled}
         name={groupName}
         readOnly={readOnly}
         onChange={() => handleChange()}
         checked={value === CHECKED}
         style={{ cursor: 'pointer' }}
         className={className}
      />
   );
};

export default RadioButton;
